module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/schneider/monitor.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/schneider/monitor.png
// module id = 619
// module chunks = 0